export default __webpack_public_path__ + "static/media/pdf-icon.07877ba4.svg";